import { Motorcycle } from "@phosphor-icons/react";

export default Motorcycle
